"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._formatParamsForMultiShare = _formatParamsForMultiShare;
exports._formatParamsForQuickShare = _formatParamsForQuickShare;
exports._formatParamsForShowShare = _formatParamsForShowShare;
exports._formatParamsForShowShareV2 = _formatParamsForShowShareV2;
exports._formatParamsForSnapshot = _formatParamsForSnapshot;
exports.beforeThanAndroid = beforeThanAndroid;
exports.beforeThanIOS = beforeThanIOS;
exports.beforeThanMac = beforeThanMac;
exports.beforeThanPC = beforeThanPC;
exports.channelIDMap = void 0;
Object.defineProperty(exports, "compareVersion", {
  enumerable: true,
  get: function get() {
    return _toolBrowser.compareVersion;
  }
});
exports.filterChannel = filterChannel;
exports.filterSnapshotChannel = filterSnapshotChannel;
exports.findChannelById = findChannelById;
exports.genIdWrapper = genIdWrapper;
exports.isBase64 = isBase64;
exports.isSupportPassShare = isSupportPassShare;
exports.laterThanAndroid = laterThanAndroid;
exports.laterThanIOS = laterThanIOS;
exports.laterThanMac = laterThanMac;
exports.laterThanPC = laterThanPC;
exports.transChannelToOpposite = transChannelToOpposite;
var _toolBrowser = _interopRequireWildcard(require("@futuweb/tool-browser"));
var browser = _toolBrowser;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
// 枚举类型参看文档，这里是通用的，涉及多个协议 http://fservice.server.com/repository/project/1190057/proto-space/4691/main/-/setShareConfig.md?method_branch=main
// 标号必须为2的N次方
var channelIDMap = exports.channelIDMap = {
  niuyou: 0x01,
  chatRoom: 0x02,
  nnq: 0x04,
  wxFriend: 0x08,
  wxTimeline: 0x10,
  qq: 0x20,
  weibo: 0x40,
  facebook: 0x80,
  twitter: 0x0100,
  whatsapp: 0x0200,
  sms: 0x0400,
  email: 0x0800,
  copy: 0x1000,
  system: 0x2000,
  // 系统分享
  messenger: 0x04000,
  // messenger和instagram：ios>=11.5.1407 android>=11.6.1607
  instagram: 0x08000,
  dingtalk: 0X10000,
  line: 0X40000,
  telegram: 0X80000,
  xiaohongshu: 0x100000,
  reddit: 0x200000
};

/**
 * [filterChannel 普通分享渠道的筛选，并做|操作]
 * @param  {String|Array} filterOptions [渠道数组，或者单个渠道命名]
 * @return {Number}  [多个渠道|操作的结果]
 */
function filterChannel(filterOptions) {
  var result = 0;
  if (filterOptions) {
    if (filterOptions === 'all') {
      result = 0xFFFF;
    } else {
      if (typeof filterOptions === 'string') {
        filterOptions = [filterOptions];
      }
      for (var i = 0, len = filterOptions.length; i < len; ++i) {
        result |= channelIDMap[filterOptions[i]] || 0;
      }
    }
  }
  return result;
}

/**
 * [filterSnapshotChannel 普通分享渠道的筛选，并做|操作]
 * @param  {JSON} filterOptions [map结构，对分享渠道的开与管，{wxFriend：true，wxTimeline：true} ]
 * @return {Number}  [多个渠道|操作的结果]
 */
function filterSnapshotChannel(filterOptions) {
  // 标号必须为2的N次方
  var snapshotIDMap = {
    niuyou: {
      id: channelIDMap.niuyou,
      // 该渠道默认的开启模式，如果不对该渠道做设置则使用该默认值
      "switch": true
    },
    chatRoom: {
      id: channelIDMap.chatRoom,
      "switch": true
    },
    nnq: {
      id: channelIDMap.nnq,
      "switch": true
    },
    wxFriend: {
      id: channelIDMap.wxFriend,
      "switch": true
    },
    wxTimeline: {
      id: channelIDMap.wxTimeline,
      "switch": true
    },
    qq: {
      id: channelIDMap.qq,
      "switch": true
    },
    weibo: {
      id: channelIDMap.weibo,
      "switch": true
    },
    facebook: {
      id: channelIDMap.facebook,
      "switch": true
    },
    twitter: {
      id: channelIDMap.twitter,
      "switch": true
    },
    whatsapp: {
      id: channelIDMap.whatsapp,
      "switch": true
    },
    dingtalk: {
      id: channelIDMap.dingtalk,
      "switch": true
    },
    line: {
      id: channelIDMap.line,
      "switch": true
    },
    telegram: {
      id: channelIDMap.telegram,
      "switch": true
    },
    xiaohongshu: {
      id: channelIDMap.xiaohongshu,
      "switch": true
    },
    reddit: {
      id: channelIDMap.reddit,
      "switch": true
    }
  };
  var channelSwitch = 0;
  var snapshotChannel = 0;
  filterOptions = filterOptions || {};
  for (var channel in snapshotIDMap) {
    if (Object.prototype.hasOwnProperty.call(snapshotIDMap, channel)) {
      var item = snapshotIDMap[channel];
      snapshotChannel |= item.id;

      // 如果设置了渠道，则根据使用者的配置来设置
      if (Object.prototype.hasOwnProperty.call(filterOptions, channel)) {
        channelSwitch |= filterOptions[channel] ? snapshotIDMap[channel].id : 0;
        // 未设置渠道，则采用默认值
      } else {
        channelSwitch |= item["switch"] ? item.id : 0;
      }
    }
  }
  return snapshotChannel + '/' + channelSwitch;
}

/**
 * 根据channelid 返回channel名称
 * returns {String} [channel]
 */
function findChannelById(id) {
  var txt = '';
  if (!id) {
    return txt;
  }
  for (var key in channelIDMap) {
    if (Object.prototype.hasOwnProperty.call(channelIDMap, key) && channelIDMap[key] - id === 0) {
      return key;
    }
  }
  return txt;
}

/**
 * [genIdWrapper 生成唯一id的包装函数]
 * @param prefix {String} 前缀
 * @return {String} id
 */
function genIdWrapper(prefix) {
  var id = 0;
  return function () {
    id += 1;
    var random = ~~(Math.random() * 10000) + '' + (new Date().getTime() + '').substr(-6);
    var res = Number(id + random).toString(36);
    return prefix ? prefix + res : res;
  };
}

/**
 * [isBase64 判断数据是否是base64]
 * @params data 数据
 * @return {Boolean} 结果
 */
function isBase64(data) {
  return /^data:\S+;base64/.test(data);
}

/**
 * [laterThanIOS ios客户端版本是否大于等于某个版本]
 * @param  {[type]} v [description]
 * @return {[type]}   [description]
 */
function laterThanIOS(v) {
  if ((0, _toolBrowser.isIOS)()) {
    var version = (0, _toolBrowser.getNNVersion)();
    if ((0, _toolBrowser.compareVersion)(version, v) >= 0) {
      return true;
    }
  }
  return false;
}

/**
 * [laterThanAndroid Android客户端版本是否大于等于某个版本]
 * @param  {[type]} v [description]
 * @return {[type]}   [description]
 */
function laterThanAndroid(v) {
  if ((0, _toolBrowser.isAndroid)()) {
    var version = (0, _toolBrowser.getNNVersion)();
    if ((0, _toolBrowser.compareVersion)(version, v) >= 0) {
      return true;
    }
  }
  return false;
}

/**
 * [laterThanMac Mac客户端版本是否大于等于某个版本]
 * @param  {[type]} v [description]
 * @return {[type]}   [description]
 */
function laterThanMac(v) {
  if ((0, _toolBrowser.isMac)()) {
    var version = (0, _toolBrowser.getNNVersion)();
    if ((0, _toolBrowser.compareVersion)(version, v) >= 0) {
      return true;
    }
  }
  return false;
}

/**
 * [laterThanPC PC客户端版本是否大于等于某个版本]
 * @param  {[type]} v [description]
 * @return {[type]}   [description]
 */
function laterThanPC(v) {
  if ((0, _toolBrowser.isPCNN)()) {
    var version = (0, _toolBrowser.getNNVersion)();
    if ((0, _toolBrowser.compareVersion)(version, v) >= 0) {
      return true;
    }
  }
  return false;
}

/**
 * [beforeThanIOS ios客户端版本是否小于某个版本]
 * @param  {[type]} v [description]
 * @return {[type]}   [description]
 */
function beforeThanIOS(v) {
  if ((0, _toolBrowser.isIOS)()) {
    var version = (0, _toolBrowser.getNNVersion)();
    if ((0, _toolBrowser.compareVersion)(version, v) < 0) {
      return true;
    }
  }
  return false;
}

/**
 * [beforeThanAndroid Android客户端版本是否小于某个版本]
 * @param  {[type]} v [description]
 * @return {[type]}   [description]
 */
function beforeThanAndroid(v) {
  if ((0, _toolBrowser.isAndroid)()) {
    var version = (0, _toolBrowser.getNNVersion)();
    if ((0, _toolBrowser.compareVersion)(version, v) < 0) {
      return true;
    }
  }
  return false;
}

/**
 * [beforeThanMac Mac客户端版本是否小于某个版本]
 * @param  {[type]} v [description]
 * @return {[type]}   [description]
 */
function beforeThanMac(v) {
  if ((0, _toolBrowser.isMac)()) {
    var version = (0, _toolBrowser.getNNVersion)();
    if ((0, _toolBrowser.compareVersion)(version, v) < 0) {
      return true;
    }
  }
  return false;
}

/**
 * [beforeThanPC PC客户端版本是否大于等于某个版本]
 * @param  {[type]} v [description]
 * @return {[type]}   [description]
 */
function beforeThanPC(v) {
  if ((0, _toolBrowser.isPCNN)()) {
    var version = (0, _toolBrowser.getNNVersion)();
    if ((0, _toolBrowser.compareVersion)(version, v) < 0) {
      return true;
    }
  }
  return false;
}

/**
 * 为兼容多图分享 格式化数据
 * @param {Object} options 选项参数
 * @return {Object}
 */
function _formatParamsForMultiShare(options, successCallback, failCallback) {
  // 格式化 images
  var images = [];
  if (options.share_image && options.share_image.images) {
    images = options.share_image.images.map(function (item) {
      return {
        img: item.img,
        title: item.title,
        isSelect: item.is_select
      };
    });
  }
  // 配置
  var config = {
    showType: options.show_type,
    enableChannel: options.enable_channel ? options.enable_channel : undefined,
    disableChannel: options.disable_channel ? options.disable_channel : undefined,
    images: images,
    _config: {
      success: function success(res) {
        return successCallback({
          result: res.result,
          channel: res.channel,
          selected_img_index: res.selectedIndex
        });
      },
      fail: function fail(res) {
        return failCallback(res);
      }
    }
  };
  return config;
}

/**
 * 为兼容快照分享 格式化数据
 * @param {Object} options 选项参数
 * @return {Object}
 */
function _formatParamsForSnapshot(options, successCallback, failCallback) {
  var image = options.share_image && options.share_image.images && options.share_image.images[0] || {};
  var enableChannel = options.enable_channel ? options.enable_channel : transChannelToOpposite(options.disable_channel);
  enableChannel = enableChannel === 'all' ? Object.keys(channelIDMap) : enableChannel;
  enableChannel = Array.isArray(enableChannel) ? enableChannel : [enableChannel];
  // 配置
  var config = {
    type: isBase64(image.img) ? 'base64' : 'url',
    data: image.img,
    success: function success(channel) {
      return successCallback({
        'result': 0,
        'channel': channel
      });
    },
    fail: function fail(channel) {
      return failCallback({
        'result': 600,
        'channel': channel
      });
    },
    channelOptions: {
      wxFriend: enableChannel.includes('wxFriend'),
      wxTimeline: enableChannel.includes('wxTimeline'),
      niuyou: enableChannel.includes('niuyou'),
      chatRoom: enableChannel.includes('chatRoom'),
      nnq: enableChannel.includes('nnq'),
      qq: enableChannel.includes('qq'),
      weibo: enableChannel.includes('weibo'),
      facebook: enableChannel.includes('facebook'),
      twitter: enableChannel.includes('twitter'),
      whatsapp: enableChannel.includes('whatsapp'),
      dingtalk: enableChannel.includes('dingtalk'),
      line: enableChannel.includes('line'),
      telegram: enableChannel.includes('telegram'),
      xiaohongshu: enableChannel.includes('xiaohongshu'),
      reddit: enableChannel.includes('reddit')
    }
  };
  return config;
}

/**
 * 为兼容快照分享 格式化数据
 * @param {Object} options 选项参数
 * @return {Object}
 */
function _formatParamsForShowShare(options, successCallback, failCallback) {
  var data = options.share_data && options.share_data.common_model || {};
  // 配置
  var config = {
    link: data.url,
    title: data.title,
    desc: data.description,
    imgUrl: data.image_url,
    disabled: options.disable_channel ? options.disable_channel : transChannelToOpposite(options.enable_channel),
    linkType: data.link_type,
    // 分享配置需要此字段
    success: function success(channel) {
      return successCallback({
        result: 0,
        channel: channel
      });
    },
    fail: function fail(channel) {
      return failCallback({
        result: 600,
        channel: channel
      });
    }
  };
  return config;
}

/**
 * 为兼容结构化数据分享 格式化数据
 * @param {Object} options 选项参数
 * @return {Object}
 */
function _formatParamsForShowShareV2(options, successCallback, failCallback) {
  var disabled = options.disable_channel ? filterChannel(options.disable_channel) : undefined;
  var enable = options.enable_channel ? filterChannel(options.enable_channel) : undefined;
  // 格式化 share_data
  if (options.share_data && options.share_data.share_model_list) {
    options.share_data.share_model_list.forEach(function (item) {
      item.channel = filterChannel(item.channel);
    });
  }
  // 配置
  var config = {
    enable: enable,
    disabled: disabled,
    share_data: options.share_data,
    _config: {
      success: function success(channel) {
        return successCallback({
          result: 0,
          channel: channel
        });
      },
      fail: function fail(channel) {
        return failCallback({
          result: 600,
          channel: channel
        });
      }
    }
  };
  return config;
}

/**
 * 为兼容快速分享 格式化数据
 * @param {Object} options 选项参数
 * @return {Object}
 */
function _formatParamsForQuickShare(options) {
  var data = options.share_data && options.share_data.common_model || {};
  // 配置
  var config = {
    channel: Array.isArray(options.enable_channel) ? options.enable_channel[0] : options.enable_channel,
    link: data.url,
    title: data.title,
    desc: data.description,
    imgUrl: data.image_url
  };
  return config;
}

/**
 * [transChannelToOpposite 转化为相反的渠道列表，例如enableChannel->disableChannel]
 * @param  {Array|String} target 渠道列表
 * @return {Array}   渠道列表
 */
function transChannelToOpposite(source) {
  var res = [];
  var channels = Object.keys(channelIDMap);
  if (typeof source === 'string') {
    source = source === 'all' ? channels : [source];
  }
  if (!Array.isArray(source)) {
    source = [];
  }
  res = channels.filter(function (channel) {
    return !source.includes(channel);
  });
  return res;
}

/**
 * 是否支持口令分享
 * 安卓>=11.5.1507        ios>=11.5.1308
 * @return {Boolean}
 */
function isSupportPassShare() {
  // 判断是否nn或mm
  if (!browser.isMobileNN()) {
    return false;
  }
  if (laterThanAndroid('11.5.1507')) {
    return true;
  }
  if (laterThanIOS('11.5.1308')) {
    return true;
  }
  return false;
}